import React, { forwardRef } from 'react';
import BillingDetails from '../../shared/billingForm/dist/growth-billing-details-shared-billingForm.esm.js';
import '@growth/auth-helpers';
import { h as heading, s as subHeadingDweb, P as Platform } from '../../dist/commonTrackKeys-1035867d.esm.js';
import '@growth/browser-storage';
import '@growth/pdt-track';
import '@growth/custom-hooks/useApiCall';
import '@growth/api-calls';
import '@growth/tooltip';
import '../../dist/taggedTemplateLiteralLoose-8a80a17d.esm.js';
import 'styled-components';
import '@growth/app-theme';
import '@growth/design-system';
import '../../shared/Checkbox/dist/growth-billing-details-shared-Checkbox.esm.js';
import '../../shared/InputField/dist/growth-billing-details-shared-InputField.esm.js';
import '@growth/use-analytics';
import '../../shared/DropDownField/dweb/dist/growth-billing-details-shared-DropDownField-dweb.esm.js';
import '@growth/custom-hooks/useOutsideHandler';
import '../../shared/DropDownField/mweb/dist/growth-billing-details-shared-DropDownField-mweb.esm.js';
import '@growth/bottom-sheet';
import '@growth/custom-hooks/use100Vh';
import 'react-dom';

var BillingDetailsDweb = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onError = _ref.onError,
      onSuccess = _ref.onSuccess,
      addressDetails = _ref.addressDetails,
      lobName = _ref.lobName,
      wrapperCss = _ref.wrapperCss,
      onLoad = _ref.onLoad;
  return /*#__PURE__*/React.createElement(BillingDetails, {
    heading: heading,
    subHeading: subHeadingDweb,
    addressDetails: addressDetails,
    onError: onError,
    onSuccess: onSuccess,
    platform: Platform.dweb,
    ref: ref,
    lobName: lobName,
    wrapperCss: wrapperCss,
    onLoad: onLoad
  });
});
BillingDetailsDweb.displayName = 'BillingDetailsDweb';

export { BillingDetailsDweb };
